(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bamboo-crop-demo"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.bceReady) return;
    root.dataset.bceReady = '1';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var rows = Array.prototype.slice.call(root.querySelectorAll('.bce__row'));
    if (!rows.length) return;

    // Click a plate -> fill the Beespoke size picker (no-op if no picker on the page)
    function normSize(s) { return (s || '').toLowerCase().replace(/\s+/g, '').replace(/×/g, 'x'); }
    function currentSel() { return document.querySelector('variant-picker select'); }
    function syncPicked() {
      var sel = currentSel(), cur = null;
      if (sel && sel.value !== '' && sel.selectedIndex >= 0 && sel.options[sel.selectedIndex]) cur = normSize(sel.options[sel.selectedIndex].textContent);
      rows.forEach(function (r) {
        var m = r.querySelector('.bce__media');
        if (m) m.classList.toggle('is-picked', !!cur && normSize(m.getAttribute('data-size')) === cur);
      });
    }
    function fillSize(label) {
      var sel = currentSel();
      if (!sel) return;
      var want = normSize(label), exact = null, partial = null;
      Array.prototype.forEach.call(sel.options, function (o) {
        var n = normSize(o.textContent);
        if (!n || !want) return;
        if (n === want) exact = o;
        else if (n.indexOf(want) !== -1) partial = o;
      });
      var matched = exact || partial;
      if (!matched) return;
      sel.value = matched.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      syncPicked();
    }
    rows.forEach(function (r) {
      var media = r.querySelector('.bce__media');
      if (!media) return;
      media.addEventListener('click', function () { fillSize(media.getAttribute('data-size')); });
      media.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fillSize(media.getAttribute('data-size')); } });
    });
    document.addEventListener('variant:update', syncPicked);
    setTimeout(syncPicked, 200);

    if (reduce) { rows.forEach(function (r) { r.classList.add('is-in'); }); return; }

    root.classList.add('bce--anim');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.12 });
      rows.forEach(function (r) { io.observe(r); });
    } else { rows.forEach(function (r) { r.classList.add('is-in'); }); }

    /* ⛔ NO scroll-drift here — removed for good (BAM 2026-08-13, after two iterations).
       First version moved the plate +34px while its own caption went -62px: ~100px of
       separation between two things the eye reads as one object. Second version moved
       them together, which read as no effect at all — a rigid unit can only move with
       the page (invisible) or against its own parts (off-putting). These plates have
       visible edges and true-scale sizing; parallax only pays on clipped full-bleed
       imagery. The staggered rise-in above is this section's motion. Do not re-add. */
  }
  function boot() { document.querySelectorAll('.bce').forEach(setup); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bamboo-size-price-chart"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.bspcReady) return;
    root.dataset.bspcReady = '1';
    var stage = root.querySelector('.bspc__stage');
    var cap = root.querySelector('.bspc__cap');
    if (!stage) return;
    var prints = root.querySelectorAll('.bspc__print');
    var pills = root.querySelectorAll('.bspc__sizepill');
    var cta = root.querySelector('.bspc__shopcta');
    var bespcta = root.querySelector('.bspc__bespcta');
    var syncPicker = root.getAttribute('data-sync') === 'true';
    var beespokeMode = root.getAttribute('data-beespoke') === 'true';
    function norm(s) { return (s || '').toLowerCase().replace(/\s+/g, '').replace(/×/g, 'x'); }

    function setCaption(fig) {
      if (!fig) { cap.innerHTML = ''; return; }
      var price = fig.getAttribute('data-price');
      var besp = fig.getAttribute('data-besp');
      var html = '';
      if (beespokeMode) {
        if (besp) html = '<span class="bspc__caplbl">Beespoke</span> <strong>' + besp + '</strong>';
      } else {
        if (price) html += '<span class="bspc__caplbl">Prepared Prints</span> <strong>' + price + '</strong>';
        if (besp) html += (html ? ' <span class="bspc__capsep">·</span> ' : '') + '<span class="bspc__caplbl">Beespoke</span> <strong>' + besp + '</strong>';
      }
      cap.innerHTML = html;
    }

    function showSingle(id) {
      stage.setAttribute('data-mode', 'single');
      stage.setAttribute('data-active', id);
      var active = null;
      prints.forEach(function (p) {
        var on = p.getAttribute('data-id') === id;
        p.classList.toggle('is-active', on);
        if (on) active = p;
      });
      pills.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-value') === id); });
      setCaption(active);
      if (cta && active) { var u = active.getAttribute('data-url'); if (u) cta.setAttribute('href', u); }
      if (bespcta && active) { var bu = active.getAttribute('data-bespurl'); if (bu) bespcta.setAttribute('href', bu); }
    }

    function pushToPicker(fullLabel) {
      var sel = document.querySelector('variant-picker select');
      if (!sel) return;
      var want = norm(fullLabel), exact = null, partial = null;
      Array.prototype.forEach.call(sel.options, function (o) {
        var n = norm(o.textContent);
        if (!n || !want) return;
        if (n === want) exact = o; else if (n.indexOf(want) !== -1) partial = o;
      });
      var m = exact || partial;
      if (!m) return;
      sel.value = m.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function pullFromPicker() {
      var sel = document.querySelector('variant-picker select');
      if (!sel || sel.value === '' || sel.selectedIndex < 0 || !sel.options[sel.selectedIndex]) return;
      var lbl = norm(sel.options[sel.selectedIndex].textContent), match = null;
      pills.forEach(function (b) { if (norm(b.getAttribute('data-match')) === lbl) match = b; });
      if (match) showSingle(match.getAttribute('data-value'));
    }

    // ── Holding the viewer still while the variant syncs ──────────────────────
    // Picking a size writes the native variant picker, and Horizon then re-renders
    // the product form and media gallery above this section. Something in that
    // re-render scrolls the document. Three earlier attempts to counter it all
    // assumed a *specific* culprit and a *specific* moment, and all leaked:
    //   1) scrollTo(0, keepY) once a frame — scrollTo obeys the theme's
    //      html { scroll-behavior: smooth }, so each call restarted an eased
    //      animation that never arrived and left the page a few px off.
    //   2) same loop with behavior:'instant' — lands exactly, but only samples
    //      once a frame and only for 30 frames.
    //   3) 60 frames + scroll-behavior forced to auto — still misses, because the
    //      re-render is a fetch and the jump can land after the window closes.
    // So stop predicting when it happens. Listen for the scroll ITSELF, undo it
    // immediately, and keep listening for a generous window. Anything that moves
    // the page gets corrected, whatever caused it and whenever it fires.
    var holdTimer = 0, holdAbort = null;
    pills.forEach(function (b) {
      b.addEventListener('click', function () {
        var anchor = stage.getBoundingClientRect().top;
        var docEl = document.documentElement;
        var prevBehavior = docEl.style.scrollBehavior;

        if (holdAbort) holdAbort.abort();
        if (holdTimer) clearTimeout(holdTimer);
        holdAbort = new AbortController();
        var sig = holdAbort.signal;
        // Forced instant so a programmatic scroll lands in one frame instead of
        // easing past us, and so our own correction is not itself animated.
        docEl.style.scrollBehavior = 'auto';

        var released = false;
        function release() {
          if (released) return;
          released = true;
          docEl.style.scrollBehavior = prevBehavior;
          if (holdTimer) clearTimeout(holdTimer);
          holdTimer = 0;
          if (holdAbort) holdAbort.abort();
        }

        // The buyer's own scroll always wins and ends the hold immediately.
        // pointerdown/mousedown cover dragging the scrollbar, which fires no wheel.
        ['wheel', 'touchstart', 'pointerdown', 'mousedown', 'keydown'].forEach(function (evt) {
          window.addEventListener(evt, release, { passive: true, signal: sig });
        });

        window.addEventListener('scroll', function () {
          if (released) return;
          var drift = stage.getBoundingClientRect().top - anchor;
          // Our own correction re-fires this listener, but by then drift is 0, so
          // it settles on the next pass instead of looping.
          if (Math.abs(drift) > 0.5) window.scrollBy({ top: drift, behavior: 'instant' });
        }, { passive: true, signal: sig });

        showSingle(b.getAttribute('data-value'));
        if (syncPicker) pushToPicker(b.getAttribute('data-match'));

        holdTimer = setTimeout(release, 2000);
      });
    });

    var toplink = root.querySelector('.bspc__toplink');
    if (toplink) {
      toplink.addEventListener('click', function () {
        var t = document.getElementById('beespoke-photo-name') || document.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('variant-picker');
        if (t && t.scrollIntoView) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
        else window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    showSingle(stage.getAttribute('data-active'));

    if (syncPicker) {
      document.addEventListener('variant:update', pullFromPicker);
      setTimeout(pullFromPicker, 250);
    }
  }
  function boot() { document.querySelectorAll('.bspc').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["print-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.bam-pg');
    if (!section) return;
    var tiles = Array.prototype.slice.call(section.querySelectorAll('.bam-pg__tile'));

    // the stock Print dropdown in the buy box (re-rendered on variant updates — query fresh)
    function printSelect() {
      return document.querySelector('.variant-option--dropdowns .variant-option__select');
    }
    function markByVariantId(vid) {
      tiles.forEach(function (t) {
        var s = t.querySelector('.bam-pg__select');
        t.classList.toggle('is-selected', !!s && s.getAttribute('data-variant-id') === vid);
      });
    }
    function syncFromSelect() {
      var sel = printSelect();
      if (!sel) return;
      var o = sel.options[sel.selectedIndex];
      if (o) markByVariantId(o.getAttribute('data-variant-id'));
    }

    // select a variant by id — drives the dropdown (price, photo, marker all follow). Shared by tiles + lightbox.
    function selectByVariantId(vid) {
      var sel = printSelect();
      if (sel) {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].getAttribute('data-variant-id') === vid) {
            if (sel.selectedIndex !== i) { sel.selectedIndex = i; sel.dispatchEvent(new Event('change', { bubbles: true })); }
            break;
          }
        }
      }
      markByVariantId(vid);
    }
    // gallery click → select (same pattern as the Beespoke crop demo)
    Array.prototype.forEach.call(section.querySelectorAll('.bam-pg__select'), function (btn) {
      btn.addEventListener('click', function () { selectByVariantId(btn.getAttribute('data-variant-id')); });
    });

    // ===== bee-select: enhance the native Print <select> into the Beespoke-style panel =====
    var SIZE_RANK = { tiny: 0, small: 1, medium: 2, large: 3 };
    function cleanLabel(o) { return o.textContent.trim().replace(/\s+-\s+.*$/, ''); }
    function labelParts(label) {
      var w = label.split(/\s+/);
      return { dims: w[w.length - 1], size: (w[w.length - 2] || ''), name: w.slice(0, w.length - 2).join(' ') };
    }
    function closeAllBee() {
      var L = document.querySelectorAll('.bee-select__list');
      for (var i = 0; i < L.length; i++) { L[i].hidden = true; var t = L[i].previousElementSibling; if (t) t.setAttribute('aria-expanded', 'false'); }
    }
    function buildBeeList(sel) {
      var items = [];
      Array.prototype.forEach.call(sel.options, function (o) {
        if (o.value === '') return;
        var p = labelParts(cleanLabel(o));
        items.push({ value: o.value, name: p.name, size: p.size, dims: p.dims, rank: (SIZE_RANK[p.size.toLowerCase()] != null ? SIZE_RANK[p.size.toLowerCase()] : 99) });
      });
      var groups = {}, order = [];
      items.forEach(function (it) { if (!groups[it.size]) { groups[it.size] = []; order.push(it); } groups[it.size].push(it); });
      order.sort(function (a, b) { return a.rank - b.rank; });
      var html = '';
      order.forEach(function (g) {
        html += '<li class="bee-select__group" role="presentation">' + g.size + '</li>';
        groups[g.size].forEach(function (it) {
          var on = (it.value === sel.value && sel.value !== '');
          html += '<li class="bee-select__option' + (on ? ' is-selected' : '') + '" role="option"' + (on ? ' aria-selected="true"' : '') +
                  ' data-value="' + String(it.value).replace(/"/g, '&quot;') + '">' + it.name + '&nbsp;&nbsp;' + it.dims + '</li>';
        });
      });
      return html;
    }
    function refreshBee(sel, ui) {
      var valEl = ui.querySelector('.bee-select__value');
      var o = sel.options[sel.selectedIndex];
      var txt = (sel.value && o) ? cleanLabel(o) : 'Pick a Print...';
      if (valEl && valEl.textContent !== txt) valEl.textContent = txt;
      var opts = ui.querySelectorAll('.bee-select__option');
      for (var i = 0; i < opts.length; i++) {
        var on = (opts[i].dataset.value === sel.value && sel.value !== '');
        opts[i].classList.toggle('is-selected', on);
        if (on) opts[i].setAttribute('aria-selected', 'true'); else opts[i].removeAttribute('aria-selected');
      }
    }
    function enhanceBee() {
      var sel = printSelect();
      if (!sel) return;
      var wrapper = sel.closest('.variant-option__select-wrapper') || sel;
      var existing = document.querySelector('.bee-select');
      if (sel.dataset.beeReady === '1' && existing) { refreshBee(sel, existing); return; }
      if (existing) existing.remove();
      wrapper.classList.add('bee-native-hidden');
      sel.dataset.beeReady = '1';
      var ui = document.createElement('div');
      ui.className = 'bee-select';
      ui.innerHTML = '<button type="button" class="bee-select__toggle" aria-haspopup="listbox" aria-expanded="false"><span class="bee-select__value"></span><span class="bee-select__caret" aria-hidden="true"></span></button><ul class="bee-select__list" role="listbox" hidden>' + buildBeeList(sel) + '</ul>';
      wrapper.parentNode.insertBefore(ui, wrapper.nextSibling);
      var toggle = ui.querySelector('.bee-select__toggle'), list = ui.querySelector('.bee-select__list');
      refreshBee(sel, ui);
      toggle.addEventListener('click', function () { var willOpen = list.hidden; closeAllBee(); list.hidden = !willOpen; toggle.setAttribute('aria-expanded', String(willOpen)); });
      list.addEventListener('click', function (e) {
        var li = e.target.closest('.bee-select__option'); if (!li) return;
        sel.value = li.dataset.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        list.hidden = true; toggle.setAttribute('aria-expanded', 'false');
        refreshBee(sel, ui);
      });
    }

    // dropdown / gallery / anything changes the variant → move the 🌼 + refresh the panel
    document.addEventListener('change', function (e) {
      var sel = printSelect();
      if (sel && e.target === sel) {
        syncFromSelect();
        var ui = document.querySelector('.bee-select');
        if (ui) refreshBee(sel, ui);
      }
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.bee-select')) closeAllBee(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllBee(); });
    document.addEventListener('variant:update', function () { setTimeout(function () { enhanceBee(); syncFromSelect(); }, 40); });
    enhanceBee();
    syncFromSelect(); // stock behavior: first/URL variant is selected on load — mark it
    var vpEl = document.querySelector('variant-picker');
    if (vpEl && window.MutationObserver) {
      var moBee = false;
      new MutationObserver(function () { if (moBee) return; moBee = true; requestAnimationFrame(function () { moBee = false; enhanceBee(); }); }).observe(vpEl, { childList: true, subtree: true });
    }

    // zoom lightbox
    var lb = section.querySelector('.bam-pg__lightbox');
    var lbImg = section.querySelector('.bam-pg__lb-img');
    var lbCap = section.querySelector('.bam-pg__lb-cap');
    // ordered list of every print (for prev/next navigation inside the lightbox)
    var zoomBtns = Array.prototype.slice.call(section.querySelectorAll('.bam-pg__zoom'));
    var lbItems = zoomBtns.map(function (z) {
      var tile = z.closest('.bam-pg__tile');
      return { src: z.getAttribute('data-zoom'), name: z.getAttribute('data-zoom-name'), vid: tile ? tile.getAttribute('data-variant-id') : null };
    });
    var lbIndex = 0;
    function showLB(i) {
      if (!lbItems.length) return;
      lbIndex = (i + lbItems.length) % lbItems.length;   // wrap around
      var it = lbItems[lbIndex];
      lbImg.src = it.src; lbImg.alt = it.name; lbCap.textContent = it.name;
      if (it.vid) selectByVariantId(it.vid);   // navigating the lightbox actually selects the print
    }
    function openLB(i) { showLB(i); lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); }
    function closeLB() { lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); lbImg.src = ''; }
    zoomBtns.forEach(function (z, i) {
      z.addEventListener('click', function (e) { e.stopPropagation(); openLB(i); });
    });
    section.querySelector('.bam-pg__lb-close').addEventListener('click', closeLB);
    section.querySelector('.bam-pg__lb-prev').addEventListener('click', function (e) { e.stopPropagation(); showLB(lbIndex - 1); });
    section.querySelector('.bam-pg__lb-next').addEventListener('click', function (e) { e.stopPropagation(); showLB(lbIndex + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLB(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLB();
      else if (e.key === 'ArrowLeft') showLB(lbIndex - 1);
      else if (e.key === 'ArrowRight') showLB(lbIndex + 1);
    });

    // motion: staggered rise-in (scroll-drift removed 2026-08-13 — see the note below)
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce && 'IntersectionObserver' in window) {
      section.classList.add('bam-pg--anim');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      tiles.forEach(function (t) { io.observe(t); });

      /* ⛔ NO scroll-drift here — removed for good (BAM 2026-08-13, after two iterations).
         These photographs have VISIBLE EDGES and captions: rigid units. Move a unit a
         little and it reads as nothing ("everything moves in unison"); move its parts
         separately and the tile dismembers (the old ±30px alternating shear). Parallax
         only pays on clipped full-bleed imagery, which this gallery deliberately is not.
         The staggered rise-in above is this section's motion. Do not re-add. */
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wallpaper-library"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Matching lives in assets/bam-search.js so every search box on the site behaves
     identically. These are thin delegates; resolved at call time so load order cannot
     bite. Do not reintroduce a local copy of the stemmer or the synonym map. */
  function stem(w) { return window.BAMSearch.stem(w); }
  function tokenize(q) { return window.BAMSearch.tokenize(q); }
  function matches(a, tokens) { return window.BAMSearch.matches(a, tokens); }

  function init(root) {
    if (root.dataset.wplReady) return;
    root.dataset.wplReady = '1';
    var input = root.querySelector('.wpl__search-input');
    var results = root.querySelector('.wpl__results');
    var speechEl = root.querySelector('.wpl__butterfly-speech');
    var grid = root.querySelector('.wpl__grid');
    var pager = root.querySelector('.wpl__pagination');
    if (!input || !results || !grid) return;

    var index = null, loading = null, token = 0;

    /* ── LOAD MORE (BAM 2026-08-13) ────────────────────────────────────────────────
       Replaces the Previous/Next pager whenever JS is up (the server pager stays in the
       markup for crawlers and no-JS visitors). Two jobs:
       1. Append the next page's cards below instead of navigating away.
       2. Keep every visible row FULL. Gated articles are skipped AFTER `paginate by 48`,
          so a page renders 48-minus-gated cards — rarely a multiple of the column count,
          which is why the last row always sat short. The grid is trimmed to whole rows
          and the offcuts wait at the FRONT of a queue; every append drains the queue
          first, so nothing is lost and order is preserved. Only the true end of the
          library flushes a short row, where a short row is honest.
       Lives inside .wpl__pagination on purpose: the search feature already hides and
       restores that nav, so the button follows the search state with zero extra wiring.
       Fetches use the Section Rendering API (?section_id=…) — the response is this
       section alone, not the whole page. Any failure falls back to plain navigation,
       which is exactly what the link it replaced would have done. */
    (function () {
      if (!pager) return;
      var nextEl = pager.querySelector('[data-wpl-next]');
      var nextUrl = nextEl ? nextEl.getAttribute('href') : null;
      /* the theme's javascript block takes no Liquid, so the section id comes off the wrapper */
      var sectionId = (root.closest('.shopify-section') || {}).id || '';
      sectionId = sectionId.replace('shopify-section-', '');
      var queue = [];

      function cols() {
        var n = getComputedStyle(grid).gridTemplateColumns.split(' ').length;
        return n > 0 ? n : 3;
      }
      function trim() {
        var cards = grid.querySelectorAll('.wpl__card');
        var keep = Math.floor(cards.length / cols()) * cols();
        for (var i = cards.length - 1; i >= keep; i--) queue.unshift(grid.removeChild(cards[i]));
      }
      function flush() {
        queue.forEach(function (c) { grid.appendChild(c); });
        queue = [];
      }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'button button-secondary wpl__page-btn';
      btn.textContent = 'Load More';
      pager.textContent = '';
      pager.appendChild(btn);

      /* hold offcuts back only while there are more pages to refill from */
      if (nextUrl) trim();
      if (!nextUrl && !queue.length) { pager.remove(); return; }

      /* iPad rotation changes the column count — re-balance the row boundary */
      var rt;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () {
          if (nextUrl || queue.length) { flush(); trim(); }
        }, 150);
      });

      var busy = false;
      btn.addEventListener('click', function () {
        if (busy) return;
        if (!nextUrl) { flush(); pager.remove(); return; }
        busy = true; btn.disabled = true; btn.textContent = 'Loading…';
        var sep = nextUrl.indexOf('?') === -1 ? '?' : '&';
        fetch(nextUrl + sep + 'section_id=' + encodeURIComponent(sectionId))
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var cards = doc.querySelectorAll('.wpl__grid .wpl__card');
            if (!cards.length) throw new Error('no cards in response');
            flush();
            cards.forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
            var nn = doc.querySelector('[data-wpl-next]');
            nextUrl = nn ? nn.getAttribute('href') : null;
            if (nextUrl) {
              trim();
              busy = false; btn.disabled = false; btn.textContent = 'Load More';
            } else {
              pager.remove();
            }
          })
          .catch(function () {
            /* degraded network or a rendering-API surprise: do what the old link did */
            if (nextUrl) window.location.href = nextUrl;
          });
      });
    })();

    function decode(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector('[data-fieldnotes-index]');
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }

    function loadIndex() {
      if (index) return Promise.resolve(index);
      if (loading) return loading;
      loading = fetch('/?section_id=fieldnotes-index&page=1')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var first = decode(html);
          if (!first) throw new Error('no index');
          var rest = [];
          for (var p = 2; p <= first.pages; p++) {
            rest.push(fetch('/?section_id=fieldnotes-index&page=' + p)
              .then(function (r) { return r.text(); }).then(decode));
          }
          return Promise.all(rest).then(function (pages) {
            var all = first.articles.slice();
            pages.forEach(function (d) { if (d && d.articles) all = all.concat(d.articles); });
            /* members-only photographs must never surface here */
            all = all.filter(function (a) {
              return (a.tags || []).indexOf('exclusive-nature-content') === -1;
            });
            all.forEach(function (a) {
              var hay = (a.title + ' ' + (a.tags || []).join(' ')).toLowerCase();
              a._raw = hay.split(/[^a-z0-9]+/).filter(Boolean);
              a._words = a._raw.map(stem);
              a._base = a.title.replace(/ /g, '_');
            });
            index = all;
            return index;
          });
        });
      return loading;
    }

    /* Byte-identical to snippets/bam-arrow.liquid. These cards are built in JS, so the
     snippet cannot be rendered here — change one, change the other. */
  var ARROW = '<svg class="bam-arrow wpl__arrow" width="0.95em" height="0.95em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3.5 12h16"/><path d="M13.5 6L19.5 12l-6 6"/></svg>';

  function fileUrl(base, crop) {
      return '/cdn/shop/files/' + encodeURIComponent(base + '-' + crop + '.jpg');
    }

    function card(a) {
      var esc = function (s) { return String(s).replace(/"/g, '&quot;'); };
      return '<div class="wpl__card">' +
        '<a class="wpl__thumb-link" href="' + a.url + '" aria-label="' + esc(a.title) + '">' +
          '<picture>' +
            '<source media="(max-width: 749px)" srcset="' + fileUrl(a._base, 'p') + '?width=640">' +
            '<img class="wpl__thumb" loading="lazy" src="' + (a.img || fileUrl(a._base, 's') + '?width=480') + '" alt="' + esc(a.title) + '">' +
          '</picture>' +
        '</a>' +
        '<h2 class="wpl__title">' + a.title + '</h2>' +
        '<div class="wpl__buttons">' +
          '<a class="button button-secondary wpl__btn" href="' + fileUrl(a._base, 's') + '?width=5760" target="_blank" rel="noopener" download>Standard</a>' +
          '<a class="button button-secondary wpl__btn" href="' + fileUrl(a._base, 'w') + '?width=5760" target="_blank" rel="noopener" download>Widescreen</a>' +
          '<a class="button button-secondary wpl__btn" href="' + fileUrl(a._base, 'p') + '?width=5760" target="_blank" rel="noopener" download>Phone</a>' +
        '</div>' +
        '<a class="wpl__note-link" href="' + a.url + '">See the Field Note' + ARROW + '</a>' +
      '</div>';
    }

    function restore() {
      results.hidden = true;
      results.innerHTML = '';
      if (speechEl) speechEl.innerHTML = speechEl.dataset.default || '';
      grid.style.display = '';
      if (pager) pager.style.display = '';
    }

    function search(q) {
      var mine = ++token;
      loadIndex().then(function (all) {
        if (mine !== token) return;
        var tokens = tokenize(q);
        if (!tokens.length) return restore();
        var hits = all.filter(function (a) { return matches(a, tokens); });
        grid.style.display = 'none';
        if (pager) pager.style.display = 'none';
        results.hidden = false;
        results.innerHTML = hits.length
          ? '<div class="wpl__grid">' + hits.map(card).join('') + '</div>'
          : '<p class="wpl__noresults">No wallpapers found for “' + q + '”.</p>';
        /* ⚠️ "Field Notes", NOT "wallpapers". The count is of matching FIELD NOTES,
         and each one carries THREE wallpapers (standard, widescreen, phone) — so
         "12 wallpapers" understated the real total by a factor of three and named
         the wrong thing. BAM's correction, 2026-08-28. */
      if (speechEl) speechEl.innerHTML = '\u201C' + hits.length + (hits.length === 1 ? ' Field Note' : ' Field Notes') + '\u201D';
      }).catch(function () {
        /* If the index cannot be reached, leave the normal paginated grid alone rather
           than showing an empty page. */
        restore();
      });
    }

    var clearBtn = root.querySelector('.wpl__search-clear');
    if (clearBtn) clearBtn.addEventListener('click', function () {
      input.value = '';
      clearBtn.hidden = true;
      token++;
      restore();
      input.focus();
    });

    var t;
    input.addEventListener('input', function () {
      if (clearBtn) clearBtn.hidden = !input.value;
      var q = input.value.trim();
      clearTimeout(t);
      if (q.length < 2) { token++; return restore(); }
      t = setTimeout(function () { search(q); }, 160);
    });
    /* warm the index on first focus so the first keystroke feels instant */
    input.addEventListener('focus', function () { loadIndex().catch(function () {}); }, { once: true });
  }

  function boot() { document.querySelectorAll('.wpl').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
